<template>
<ul
    :class="[
        'mdc-deprecated-list',
        twoLine && 'mdc-deprecated-list--two-line'
    ]"
    :role="listRole">
    <list-item
        v-for="(item, index) in listItems"
        :key="`menuitem-${index}`"
        :tabindex="index === 0 ? 0 : -1"
        :data-item-index="index"
        :item="item"
        @click.native="$emit('click', item)">
        <template #text="{ text }">
            <slot
                name="text"
                :text="text"></slot>
        </template>
    </list-item>
</ul>
</template>

<script>
import ListItem from "./ListItem.vue";
export default {
    components: { ListItem },
    props: {
        menu: Boolean,
        select: Boolean,
        twoLine: Boolean,
        items: { type: Array, default: () => [] }
    },
    computed: {
        listRole() {
            return this.menu ? "menu" : this.select ? "listbox" : null;
        },
        listItems() {
            const { items } = this;
            if (!items) return [];
            return this.process(items);
        }
    },
    methods: {
        process(items) {
            const role = this.menu ? "menuitem" : this.select ? "option" : null;
            return items.map(o => {
                if (typeof o === "string") return { text: o, role };
                return o;
            });
        }
    }
};
</script>
